import client from './client'

const apiBasePath = '/api/admin/account/'

export default {
  register: entryForm => client.post(apiBasePath + 'register', entryForm),
  search: entryForm => client.post(apiBasePath + 'search', entryForm),
  detail: entryForm => client.post(apiBasePath + 'detail', entryForm),
  update: entryForm => client.post(apiBasePath + 'update', entryForm),
  delete: entryForm => client.post(apiBasePath + 'delete', entryForm),
  passwordReset: entryForm => client.post(apiBasePath + 'password-reset', entryForm),
  download: () => client.post(apiBasePath + 'download')
}
